module.exports = __webpack_public_path__ + "/assets/imgs/homescreen-V2_favicon-32x32.png";